<div class="bg-white p-4 flex flex-col gap-2.5 h-full">
    <div class="relative h-[160px]" [ngClass]="{'cursor-pointer': hasImagesToShow}" (click)="openImageViewer($event)">
        <img
            class="object-cover"
            [ngClass]="{'cursor-pointer': hasImagesToShow}"
            fill
            [ngSrc]="imageUrl"
            [alt]="'Image ' + lot.lotId"
            [priority]="index < 8"
            (error)="onImageLoadError($event)"
        />
        <img *ngIf="hasImagesToShow" class="absolute top-2 right-2" src="assets/icons/search-white.svg" alt="Zoom">
    </div>
    <p class="m-0 typography-title-s">
        {{(lot.bundleId ? 'natural_stone.bundle_id' : 'natural_stone.lot') | translate}}&nbsp;{{lot.bundleId ? lot.bundleId : lot.lotId}}
    </p>
    <div class="flex flex-col gap-2">
        <p *ngIf="thickness" class="m-0 typography-body-s-light">
            {{'global.thickness' | translate}}: {{(getThickness() | number: '1.0-1') + ' cm'}}
        </p>
        <p *ngIf="finish" class="m-0 typography-body-s-light">
            {{'global.finish' | translate}}: {{finishLabel ? finishLabel : finish}}
        </p>
        <p *ngIf="getWidth() && getHeight()" class="m-0 typography-body-s-light">
            {{'global.size' | translate}}: {{(getWidth() | number: '1.0-2') + ' x ' + (getHeight() | number: '1.0-2') + getMeasureUnit()}}
        </p>
        <p *ngIf="getSurfaceArea()" class="m-0 typography-body-s-light">
            {{'global.surface_area' | translate}}: {{(getSurfaceArea() | number: '1.0-2') + getSurfaceAreaMeasure()}}
        </p>
    </div>
    <div class="px-4 py-2 bg-background-light-00 flex items-center justify-center">
        <p class="m-0 typography-body-s-regular text-text-secondary">
            {{'natural_stone.available_slabs' | translate: {varSlabs: getAvailableSlabs()}  }}
        </p>
    </div>
    <div class="flex gap-2">
        <div class="flex-1">
            <app-number-stepper
                [size]="'small'"
                [min]="getAvailableSlabs() > 0 ? 1 : 0"
                [max]="getAvailableSlabs()"
                (valueChange)="qtyToAddToCartChanged($event)"
            ></app-number-stepper>
        </div>
        <div class="flex-1">
            <app-button
                [primary]="true"
                [size]="'medium'"
                [disabled]="qtyToAddToCart <= 0"
                [isFullWidth]="true"
                [isFullHeight]="true"
                (click)="addToCart()"
            >
                {{'global.add' | translate}}
            </app-button>
        </div>
    </div>
</div>
